<template>
  <ul class="nav nav-mobile-menu">
    <!--    <li>-->
    <!--      <drop-down id="notification-list-mobile-menu">-->
    <!--        <a-->
    <!--          slot="title"-->
    <!--          class="dropdown-toggle"-->
    <!--          data-toggle="dropdown"-->
    <!--          href="javascript:void(0)"-->
    <!--        >-->
    <!--          <i class="material-icons">notifications</i>-->
    <!--          <span class="notification">{{ unreadNotifications }}</span>-->
    <!--          <p>{{ $t("common.new_notification") }}</p>-->
    <!--        </a>-->
    <!--        <ul-->
    <!--          class="dropdown-menu dropdown-menu-right notification-button custom-scrollbar"-->
    <!--        >-->
    <!--          <li-->
    <!--            class="item-notification"-->
    <!--            v-for="(notification, $index) in notifications"-->
    <!--            :key="'mobile-menu-notification-' + notification.id"-->
    <!--            :data-num="$index + 1"-->
    <!--          >-->
    <!--            <a-->
    <!--              href="javascript:void(0)"-->
    <!--              class="notification-box"-->
    <!--              :class="[-->
    <!--                { 'unread-notification': notification.read_at === null },-->
    <!--                {-->
    <!--                  'read-notification': notification.read_at !== null-->
    <!--                }-->
    <!--              ]"-->
    <!--            >-->
    <!--              <div class="md-layout">-->
    <!--                <div-->
    <!--                  class="md-layout-item md-size-20 md-small-size-20 no-padding"-->
    <!--                >-->
    <!--                  <div class="box-notification-image">-->
    <!--                    <div class="notification-image">-->
    <!--                      <progressive-img-->
    <!--                        :src="notification.data ? notification.data.image : ''"-->
    <!--                        fallback="/img/default-avatar.png"-->
    <!--                      />-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div-->
    <!--                  class="md-layout-item md-size-80 md-small-size-80 notification-title-layout"-->
    <!--                >-->
    <!--                  <div-->
    <!--                    class="notification-title-text"-->
    <!--                    v-html="-->
    <!--                      notification.data ? notification.data.title_html : ''-->
    <!--                    "-->
    <!--                  ></div>-->

    <!--                  <p-->
    <!--                    class="notification-time"-->
    <!--                    :class="[-->
    <!--                      {-->
    <!--                        'unread-notification-time':-->
    <!--                          notification.read_at === null-->
    <!--                      }-->
    <!--                    ]"-->
    <!--                  >-->
    <!--                    {{ notification.created_at | formatTimeAgo }}-->
    <!--                  </p>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </a>-->
    <!--          </li>-->
    <!--          <li>-->
    <!--            <router-link-->
    <!--              :to="{-->
    <!--                name: 'ProfileUser'-->
    <!--              }"-->
    <!--            >-->
    <!--              {{ $t("notification.view_all") }}-->
    <!--            </router-link>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </drop-down>-->
    <!--    </li>-->
    <li>
      <a href="#" data-toggle="dropdown" class="dropdown-toggle"
        ><i class="material-icons">person</i>
        <p>Account</p></a
      >
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      search: null,
      notifications: [],
      path: "/notifications",
      unreadNotifications: 0
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.alert.alert-info:hover {
  background-color: #eeeeee !important;
}

.unread-notification {
  background-color: #eaf3ff;
  color: #050505 !important;
  .notification-title-text {
    color: black;
  }
  &:hover,
  &:active,
  &:focus {
    .notification-title-text {
      color: #fff;
    }
  }
}
.notification-time {
  font-size: 11px !important;
  margin: 0 !important;
  line-height: 20px !important;
}
.unread-notification-time {
  color: #1876f2;
  font-weight: 600 !important;
}

.read-notification {
  background: none;
  color: #65676b !important;
}

.item-notification {
  margin: 2px 0;
}

.notification-box {
  display: block !important;
}

.notification-title-text {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  word-break: break-word;
}

.notification-time {
  margin: 0;
  font-size: 11px;
}

.notification-button {
  max-height: 300px;
  overflow-x: auto;
  li a {
    .progressive-image,
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 5px;
    }
  }
}

.no-padding {
  padding: 0 !important;
}

.notification-title-layout {
  padding-left: 5px;
  padding-right: 0;
  white-space: normal;
}

.box-notification-image {
  position: relative;
  display: flex;
  width: 50px;
  height: 50px;

  .notification-image {
    float: left;
    border-radius: 50%;

    img {
      width: 100%;
    }
  }
  .progressive-image {
    overflow: hidden;
    z-index: 5;
    -webkit-box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%),
      0 4px 25px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
    box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%),
      0 4px 25px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
    -webkit-transition: opacity 300ms linear, -webkit-transform 300ms linear;
    transition: transform 300ms linear, opacity 300ms linear,
      -webkit-transform 300ms linear;
  }
}
</style>
